// Rabljena vozima page
var swiperIntro = new Swiper("#swiperIntro", {
	autoplay: true,
	cssMode: false,
	speed: 700,
	// loop: true,
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	pagination: {
		el: ".sw-intro.swiper-pagination",
		clickable: true,
	},
});

// Rabljena vozila - single page
var swiperUsed = new Swiper("#swiperUsed", {
	cssMode: false,
	speed: 700,
	loop: true,
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	navigation: {
		nextEl: ".swiper-used.swiper-button-next",
		prevEl: ".swiper-used.swiper-button-prev",
	},
	pagination: {
		el: ".swiper-used.swiper-pagination",
		clickable: true,
	},
});

var swiperFlexOnKampanjaPaketi = new Swiper("#swiperFlexOnKampanjaPaketi", {
	slidesPerView: 1.1,
	spaceBetween: 24,
});

var swiperFlexOnKampanjaModeli = new Swiper("#swiperFlexOnKampanjaModeli", {
	slidesPerView: 1.1,
	spaceBetween: 24,
});

// Eskadrila - gallery
var swiperEskadrila = new Swiper("#swiperEskadrila", {
	autoplay: true,
	cssMode: false,
	speed: 700,
	// loop: true,
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	navigation: {
		nextEl: ".swiper-eskadrila.swiper-button-next",
		prevEl: ".swiper-eskadrila.swiper-button-prev",
	},
	pagination: {
		el: ".sw-eskadrila.swiper-pagination",
		clickable: true,
	},
});
